import { OverlayContainer } from '@angular/cdk/overlay';

export interface ESPShadowDomOverlayConfig {
  selector: string;
}

export class ESPShadowDomOverlayContainer extends OverlayContainer {
  readonly ESP_OVERLAY_CONTAINER_CLASS = 'esp-overlay-container';
  constructor(
    private config: ESPShadowDomOverlayConfig,
    document: unknown,
  ) {
    super(document);
  }

  protected override _createContainer(): void {
    const shadowRoot = this._document.querySelector<Element>(
      this.config.selector,
    )?.shadowRoot;

    if (!shadowRoot) {
      super._createContainer();
      return;
    }

    const newElementWrapper = shadowRoot.querySelector('.pwc-esp');

    const container = this._document.createElement('div');
    container.classList.add(
      'cdk-overlay-container',
      'compass-overlay-container',
      this.ESP_OVERLAY_CONTAINER_CLASS,
    );

    newElementWrapper?.appendChild(container);
    this._containerElement = container;
  }
}
